const state = {
  oncostEdit: null,
  oncostDelete: null
}

export default state